import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { b } from 'utils/i18nUtils';

import { getPINCode } from 'modules/restrictedAccess/selectors';

import { Button, Input } from 'components/ui';
import { ButtonType } from 'components/ui/Button';

type PINProps = {
  onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void
};

const PINCode: React.FC<PINProps> = ({ onCancel }) => {
  const pinCode = useSelector(getPINCode);

  return (
    <>
      <div className="text-center [&>p]:inline [&>p]:mx-1">
        <FormattedMessage
          id="restrictedAccess.modal.description"
          tagName="p"
          defaultMessage="Outside the dealership's opening hours, access to the kiosk may be restricted by a gate."
        />
        <FormattedMessage
          id="restrictedAccess.modal.pinDescription"
          tagName="p"
          values={{ b }}
          defaultMessage="In this case, <b>enter the PIN code</b> below on its keyboard."
        />
      </div>
      <Input disabled center inputClassName="!p-s !w-fit mx-auto" value={pinCode} />
      <Button type={ButtonType.TERTIARY} onClick={onCancel} testId="continue-btn">
        <FormattedMessage id="socket.modal.confirm" defaultMessage="Continue" />
      </Button>
    </>
  );
};

export default PINCode;
